import { HTTP } from '../../common/http';

import {
  SET_ADVERTS,
} from './mutation-types';

export function fetchAdverts({ commit }, sourceId) {
  HTTP.get(`/adverts?source_id=${sourceId}`)
    .then(({ data }) => commit(SET_ADVERTS, data));
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/misc/actions.js